import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./ProjectGallery.css";

import {Carousel} from "react-responsive-carousel";
//import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';

import Icon from "Icon/Icon";
import Hyperlink from "Hyperlink/Hyperlink";

import projects from "projects";
import {joinClasses, isViewportMobile} from "utils";

export default class ProjectGallery extends Component
{
	componentDidMount()
	{
		window.addEventListener("resize", () =>
		{
			this.forceUpdate();
		});
	}

	render()
	{
		let filterFn;

		if(this.props.filter === "All")
		{
			filterFn = () => true;
		}
		else
		{
			filterFn = (project) =>
			{
				for(let i = 0; i < project.type.length; i++)
				{
					if(this.props.filter === project.type[i])
					{
						return true;
					}
				}

				return false;
			};
		}

		const projectElems = projects
		.filter(filterFn)
		.map((data, i) =>
		{
			let classes = joinClasses(
			[
				"project",
				(data.caseStudy && "case-study"),
			]);

			return (
				<div key={data.name} className={classes}>
					<div className="projectInner">
						<img src={data.image} alt={data.name} />

						<div className="overlay">
							<div className="overlayInner">
								<div className="name">
									{data.name}
								</div>

								<div className="type">
									{data.type.join(" - ")}
								</div>

								<div className="icons">
									{data.caseStudy &&
										<Link to={"/cases/" + data.name} className="expand">
											<Icon title="Case Study" titleBottom>book</Icon>
										</Link>
									}

									{data.website &&
										<Hyperlink href={data.website} className="expand" newTab>
											<Icon title="Website" titleBottom>view</Icon>
										</Hyperlink>
									}

									{data.github &&
										<Hyperlink href={data.github} className="expand" newTab>
											<Icon title="GitHub" titleBottom>github</Icon>
										</Hyperlink>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		});

		if(isViewportMobile())
		{
			const carouselOptions =
			{
				showArrows: false,
				showStatus: false,
				showIndicators: false,
				showThumbs: false,
			};

			return (
				<Carousel {...carouselOptions} className="project-gallery">
					{projectElems}
				</Carousel>
			);
		}
		else
		{
			return (
				<div className="project-gallery">
					{projectElems}
				</div>
			);
		}

		/*return (
			<Carousel {...carouselOptions} className="project-gallery">
				{projectElems.length > 0
					?
						projectElems
					:
						<div>Please select a category above</div>
				}
			</Carousel>
		);*/
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Portfolio/Projects/ProjectGallery/ProjectGallery.js